module.exports = __webpack_public_path__ + "img/for-the-win-logo.e1f85555.svg";